import { render, staticRenderFns } from "./VaultSecret.vue?vue&type=template&id=2c25787e&scoped=true"
import script from "./VaultSecret.vue?vue&type=script&setup=true&lang=ts"
export * from "./VaultSecret.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VaultSecret.vue?vue&type=style&index=0&id=2c25787e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25787e",
  null
  
)

export default component.exports